/* NAD Hair — Results Video Carousel
   - Scroll-snap carousel arrows
   - Click card => modal video player (YouTube/Vimeo/MP4)
*/

(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function getYouTubeId(url) {
    try {
      const u = new URL(url);
      if (u.hostname.includes("youtu.be")) return u.pathname.replace("/", "");
      if (u.searchParams.get("v")) return u.searchParams.get("v");
      const parts = u.pathname.split("/");
      const idx = parts.indexOf("embed");
      if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    } catch (e) {}
    return null;
  }

  function getVimeoId(url) {
    try {
      const u = new URL(url);
      if (!u.hostname.includes("vimeo.com")) return null;
      const parts = u.pathname.split("/").filter(Boolean);
      const last = parts[parts.length - 1];
      return last && /^\d+$/.test(last) ? last : null;
    } catch (e) {}
    return null;
  }

  function isDirectVideo(url) {
    return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url || "");
  }

  function buildPlayerHTML({ videoUrl, mp4Url }) {
    // Prefer MP4 if provided
    if (mp4Url) {
      return `<video class="nhrvc__player" controls autoplay playsinline preload="metadata" src="${mp4Url}"></video>`;
    }


    if (!videoUrl) return "";

    const yt = getYouTubeId(videoUrl);
    if (yt) {
      const src = `https://www.youtube.com/embed/${yt}?autoplay=1&mute=0&playsinline=1&rel=0`;
      return `<iframe src="${src}" title="YouTube video" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    }

    const vm = getVimeoId(videoUrl);
    if (vm) {
      const src = `https://player.vimeo.com/video/${vm}?autoplay=1&muted=0`;
      return `<iframe src="${src}" title="Vimeo video" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }

    if (isDirectVideo(videoUrl)) {
      return `<video controls autoplay playsinline src="${videoUrl}"></video>`;
    }

    // Fallback: open in new tab if unknown
    return "";
  }

  function init(root) {
    const track = qs(root, ".nhrvc__track");
    if (!track) return;

    const btnPrev = qs(root, "[data-nhrvc-prev]");
    const btnNext = qs(root, "[data-nhrvc-next]");

    const modal = qs(root, "[data-nhrvc-modal]");
    const modalBody = qs(root, "[data-nhrvc-modal-body]");
    const modalDialog = qs(root, ".nhrvc__modal-dialog");
    const closeEls = qsa(root, "[data-nhrvc-close]");
    const modalMedia = qs(root, "[data-nhrvc-modal-media]");
    const ctaWrap = qs(root, "[data-nhrvc-cta]");
    let ctaTimer = null;
// Inline preview video (first card) — attempt to autoplay muted (with retries)
const firstPreview =
  root.querySelector('[data-nhrvc-inline-autoplay="1"]') ||
  root.querySelector('video[data-nhrvc-inline-preview="1"]');

function tryPlayPreview(v) {
  if (!v) return;
  try { v.muted = true; v.playsInline = true; } catch (e) {}

  const attempt = () => {
    try {
      const p = v.play();
      if (p && typeof p.catch === "function") {
        p.catch(() => {
          // Autoplay blocked; try again on first user gesture
          const once = () => { attempt(); window.removeEventListener("pointerdown", once); };
          window.addEventListener("pointerdown", once, { once: true, passive: true });
        });
      }
    } catch (e) {}
  };

  // Try immediately, then again once it can play
  requestAnimationFrame(attempt);
  v.addEventListener("canplay", attempt, { once: true });
}

tryPlayPreview(firstPreview);



    function getStep() {
      const slide = track.querySelector(".nhrvc__slide");
      if (!slide) return Math.max(260, track.clientWidth * 0.85);

      const rect = slide.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return rect.width + gap;
    }

    function updateButtons() {
      if (!btnPrev || !btnNext) return;

      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      const x = track.scrollLeft;

      btnPrev.disabled = x <= 2;
      btnNext.disabled = x >= maxScrollLeft;
    }

    if (btnPrev && btnNext) {
      btnPrev.addEventListener("click", function () {
        track.scrollBy({ left: -getStep(), behavior: "smooth" });
      });
      btnNext.addEventListener("click", function () {
        track.scrollBy({ left: getStep(), behavior: "smooth" });
      });

      track.addEventListener("scroll", function () {
        window.requestAnimationFrame(updateButtons);
      });

      window.addEventListener("resize", function () {
        window.requestAnimationFrame(updateButtons);
      });

      updateButtons();
function parseItems(str) {
  // Accept: "123:1,456,789:2"
  const out = [];
  (str || "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean)
    .forEach(part => {
      const [idRaw, qtyRaw] = part.split(":").map(x => (x || "").trim());
      const id = Number(idRaw);
      const qty = qtyRaw ? Number(qtyRaw) : 1;
      if (!Number.isFinite(id) || id <= 0) return;
      const q = Number.isFinite(qty) && qty > 0 ? qty : 1;
      out.push({ id, qty: q });
    });

  // Your requirement: up to 10 items per button
  return out.slice(0, 10);
}

function buildCartPermalink(items) {
  // /cart/123:1,456:1,789:2?checkout
  const path = (items || []).map(i => `${i.id}:${i.qty}`).join(",");
  if (!path) return null;
  return `/cart/${path}?checkout`;
}

function hideCtas() {
  if (ctaTimer) window.clearTimeout(ctaTimer);
  ctaTimer = null;

  if (!ctaWrap) return;

  ctaWrap.classList.remove("is-visible");
  ctaWrap.setAttribute("aria-hidden", "true");

  // Collapse the entire CTA overlay by default
  ctaWrap.style.display = "none";

  ctaWrap.querySelectorAll("[data-nhrvc-cta-btn]").forEach(btn => {
    btn.hidden = true;
    btn.textContent = "";
    btn.removeAttribute("data-items");
    delete btn.dataset.items;
  });
}


function scheduleCtas() {
  hideCtas();

  if (!modalBody || !ctaWrap) return;

  const ctas = [
    { label: modalBody.getAttribute("data-cta1-label"), items: modalBody.getAttribute("data-cta1-items") },
    { label: modalBody.getAttribute("data-cta2-label"), items: modalBody.getAttribute("data-cta2-items") },
    { label: modalBody.getAttribute("data-cta3-label"), items: modalBody.getAttribute("data-cta3-items") }
  ];

  let any = false;

  ctas.forEach((cfg, idx) => {
    const btn = ctaWrap.querySelector(`[data-nhrvc-cta-btn="${idx + 1}"]`);
    if (!btn) return;

    // HARD RESET every time (prevents “empty but clickable” states)
    btn.hidden = true;
    btn.textContent = "";
    btn.removeAttribute("data-items");
    delete btn.dataset.items;

    const label = (cfg.label || "").trim();
    const itemsStr = (cfg.items || "").trim();
    const parsed = parseItems(itemsStr);

    // Only show if BOTH label + valid items exist
    if (label && parsed.length) {
      btn.textContent = label;
      btn.dataset.items = JSON.stringify(parsed);
      btn.hidden = false;
      any = true;
    }
  });

  // If nothing is valid, keep the whole overlay collapsed
  if (!any) {
    ctaWrap.style.display = "none";
    return;
  }

  // We have at least one valid CTA: enable the overlay
  ctaWrap.style.display = "grid";

  // Ensure hidden state is applied before we animate in
  ctaWrap.classList.remove("is-visible");
  ctaWrap.setAttribute("aria-hidden", "true");

  // Show CTA buttons after 3 seconds (smooth)
  ctaTimer = window.setTimeout(() => {
    ctaWrap.setAttribute("aria-hidden", "false");
    ctaWrap.classList.add("is-visible");
  }, 3000);
}


// Click => build permalink => go to checkout
if (ctaWrap) {
  ctaWrap.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-nhrvc-cta-btn]");
    if (!btn || btn.hidden) return;

    let items = [];
    try { items = JSON.parse(btn.dataset.items || "[]"); } catch (err) {}

    const url = buildCartPermalink(items);
    if (!url) return;

    window.location.href = url;
  });
}

    }
    
function openModal({ videoUrl, mp4Url }) {
  if (!modal || !modalBody) return;

  const html = buildPlayerHTML({ videoUrl, mp4Url });
// Pause any inline previews while modal is open
qsa(root, '[data-nhrvc-inline-preview="1"]').forEach(v => {
  try { v.pause(); } catch (e) {}
});


  // If unknown URL type, just open in a new tab
  if (!html && (videoUrl || mp4Url)) {
    window.open(videoUrl || mp4Url, "_blank", "noopener,noreferrer");
    return;
  }

  // Inject player (into dedicated media container so CTA overlay persists)
  if (modalMedia) modalMedia.innerHTML = html;
  else modalBody.innerHTML = html; // fallback

  // Show modal
  modal.hidden = false;
  document.documentElement.classList.add("nhrvc-modal-open");
  scheduleCtas();

  // Default while metadata loads (assume portrait 9:16)
  const DEFAULT_AR = 9 / 16; // width / height

  function fitToViewport(ar) {
    if (!modalDialog) return;

    const maxW = window.innerWidth - 24;
    const maxH = window.innerHeight - 72; // breathing room + close button

    let w = Math.min(maxW, Math.floor(maxH * ar));

    // Desktop clamp (but never exceed viewport)
    if (window.innerWidth >= 750) {
      w = Math.min(w, 560, maxW);
    }

    w = Math.max(280, w);
    modalDialog.style.width = w + "px";
  }

  // Apply default sizing immediately (works for YouTube/Vimeo too)
  modal.style.setProperty("--nhrvc-modal-ar", "9 / 16");
  modal.dataset.nhrvcAr = String(DEFAULT_AR);
  fitToViewport(DEFAULT_AR);

  // Re-fit on resize while modal is open (all player types)
  const onResize = () => {
    const ar = parseFloat(modal.dataset.nhrvcAr || String(DEFAULT_AR)) || DEFAULT_AR;
    fitToViewport(ar);
  };
  window.addEventListener("resize", onResize);
  modal._nhrvcOnResize = onResize;

  // If it's an MP4 <video>, refine sizing using real metadata
  const vid = (modalMedia || modalBody).querySelector("video.nhrvc__player");
  if (vid) {
    const apply = () => {
      if (!vid.videoWidth || !vid.videoHeight) return;

      const rawW = vid.videoWidth;
      const rawH = vid.videoHeight;

      let arW = rawW;
      let arH = rawH;
      let ar = rawW / rawH;

      // Normalize rotated portrait
      if (ar > 1.02) {
        arW = rawH;
        arH = rawW;
        ar = arW / arH;
      }

      modal.style.setProperty("--nhrvc-modal-ar", `${arW} / ${arH}`);
      modal.dataset.nhrvcAr = String(ar);
      fitToViewport(ar);
    };

    if (vid.readyState >= 1) apply();
    else vid.addEventListener("loadedmetadata", apply, { once: true });

    try { vid.play(); } catch (e) {}
  }
}

function closeModal() {
  if (!modal || !modalBody) return;

  hideCtas();

  // Remove resize listener if we added one
  if (modal._nhrvcOnResize) {
    window.removeEventListener("resize", modal._nhrvcOnResize);
    modal._nhrvcOnResize = null;
  }

  // Clear sizing state
  if (modalDialog) modalDialog.style.width = "";
  modal.style.removeProperty("--nhrvc-modal-ar");
  delete modal.dataset.nhrvcAr;

  modal.hidden = true;

  if (modalMedia) modalMedia.innerHTML = "";
  else modalBody.innerHTML = "";

  document.documentElement.classList.remove("nhrvc-modal-open");
// Resume first inline preview (if present)
if (firstPreview) {
  try {
    firstPreview.muted = true;
    const p = firstPreview.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch (e) {}
}

}


    closeEls.forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal && !modal.hidden) closeModal();
    });

    qsa(root, "[data-nhrvc-item]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const videoUrl = btn.getAttribute("data-video-url") || "";
        const mp4Url = btn.getAttribute("data-video-mp4") || "";
        openModal({ videoUrl, mp4Url });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-nhrvc]").forEach(init);
  });
})();
